import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, tap } from "rxjs";
import { IboxBalance } from "./items.interface";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ItemsService {

    private _boxBalance: ReplaySubject<IboxBalance[]> = new ReplaySubject<IboxBalance[]>(1);

    constructor(
        private http: HttpClient
    ) { }

    checkBoxBalance(wallet: string): Observable<IboxBalance[]> {
        return this.http.get(environment.apiBaseUrlV22 + 'user/' + wallet + '/items',
            { headers: { skipInterceptor: "true" } }
            ).pipe(
                tap((i: IboxBalance[]) => this._boxBalance.next(i))
            )
    }

    get boxBalance$(): Observable<IboxBalance[]> {
        return this._boxBalance.asObservable();
    }

}